import { Component, Input } from '@angular/core';
import { ValidationService } from '../../../core/services/validation.service';

@Component({
  selector: 'app-form-errors',
  imports: [],
  templateUrl: './form-errors.component.html',
  styleUrl: './form-errors.component.scss',
})
export class FormErrorsComponent {

  @Input() control!: any;
  emailRegex: any = "";
  passwordRegex: any = "";
  urlRegex: any = "";
  facebookRegex: any = "";
  instagramRegex: any = "";
  tiktokRegex: any = "";

  constructor(private validationService: ValidationService) {
    this.emailRegex = this.validationService.emailRegex;
    this.passwordRegex = this.validationService.passwordRegex;
    this.facebookRegex = this.validationService.facebookRegex;
    this.instagramRegex = this.validationService.instagramRegex;
    this.tiktokRegex = this.validationService.tiktokRegex;
    this.urlRegex = this.validationService.urlRegex;
  }
  


}
